import { Icon, IconSize, IconVariants, Modal } from "@next-platform/client-common-spicy-ui";
import { JSX, useCallback } from "react";

import { Col, Row, Text } from "./customComponents";
import Trans from "./Trans/Trans";

type PreventManageSubscriptionModalProps = {
  open: boolean;
  onClose: () => void;
};

function PreventManageSubscriptionModal({ open, onClose }: PreventManageSubscriptionModalProps): JSX.Element {
  const handleOpenChange = useCallback(
    (isModalOpen: boolean) => {
      if (!isModalOpen) {
        onClose();
      }
    },
    [onClose],
  );

  return (
    <Modal backdrop="blur" open={open} onOpenChange={handleOpenChange} data-testid="PreventManageSubscriptionModal">
      <Row justify="center">
        <Icon icon={IconVariants.DEVICE} size={IconSize.XLARGE} color="#0072F5" />
      </Row>
      <Col className="text-center gap-8">
        <Text type="medium">
          <Trans i18nKey="common:modal.preventManageSubscription.title" />
        </Text>
        <Text variant="sm">
          <Trans i18nKey="common:modal.preventManageSubscription.description" />
        </Text>
      </Col>
    </Modal>
  );
}

export default PreventManageSubscriptionModal;
